import { render, staticRenderFns } from "./ClientProfileNewForm.vue?vue&type=template&id=d6993a86&scoped=true&"
import script from "./ClientProfileNewForm.vue?vue&type=script&lang=js&"
export * from "./ClientProfileNewForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileNewForm.vue?vue&type=style&index=0&id=d6993a86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6993a86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VForm,VIcon,VRow,VSelect,VTextField})
